import { apiResourceUrl } from "@ploy-lib/core";
import { Entity } from "@rest-hooks/rest";
import { BaseCamelCasedResource } from "./BaseResource";
export var CommentType;
(function (CommentType) {
    CommentType[CommentType["NotSet"] = -1] = "NotSet";
    CommentType[CommentType["ApplicationDraft"] = 0] = "ApplicationDraft";
    CommentType[CommentType["ConditionsForApproval"] = 1] = "ConditionsForApproval";
    CommentType[CommentType["InternalComment"] = 2] = "InternalComment";
    CommentType[CommentType["LimitComment"] = 4] = "LimitComment";
    CommentType[CommentType["CreditCommentDraft"] = 5] = "CreditCommentDraft";
    CommentType[CommentType["ConditionsForApprovalWithoutLog"] = 6] = "ConditionsForApprovalWithoutLog";
    CommentType[CommentType["BeneficialOwnerComment"] = 7] = "BeneficialOwnerComment";
    CommentType[CommentType["MoneyLaunderingComment"] = 8] = "MoneyLaunderingComment";
    CommentType[CommentType["UsePurposeComment"] = 9] = "UsePurposeComment";
    CommentType[CommentType["EnhancedCustomerControlComment"] = 10] = "EnhancedCustomerControlComment";
    CommentType[CommentType["UnderwritingInfo"] = 11] = "UnderwritingInfo";
    CommentType[CommentType["UnderwritingAdjustment"] = 12] = "UnderwritingAdjustment";
    CommentType[CommentType["UnderwritingDecision"] = 13] = "UnderwritingDecision";
    CommentType[CommentType["ExternalCommentToCustomer"] = 14] = "ExternalCommentToCustomer";
})(CommentType || (CommentType = {}));
export class CommentCategoriesEntity extends Entity {
    pk() {
        return this.value;
    }
}
class CommentResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.commentId = 0;
        this.applicationId = 0;
        this.customerId = 0;
        this.customerRole = "";
        this.applicationNumber = "";
        this.commentType = CommentType.NotSet;
        this.commentText = "";
        this.commentCategory = "";
        this.commentSubCategory = "";
        this.changeDate = new Date();
        this.isDraft = false;
        this.userFullName = "";
    }
    pk() {
        return this.commentId.toString() || "";
    }
    static listUrl(allParams = {}) {
        const { customerId, applicationId, customerRole, commentType } = allParams;
        if (commentType === 7) {
            if (applicationId !== undefined) {
                return `${this.urlRoot}/customer/${applicationId}/${customerRole}/${commentType}`;
            }
            return `${this.urlRoot}/customer/${customerId}/${commentType}`;
        }
        if (applicationId !== undefined) {
            if (customerRole !== undefined) {
                return `${this.urlRoot}/${applicationId}/${customerRole}/${commentType}`;
            }
            return `${this.urlRoot}/${applicationId}/${commentType}`;
        }
        throw new Error("CommentResource requires applicationId or customerId");
    }
}
CommentResource.urlRoot = apiResourceUrl("comment");
export { CommentResource };
class CommentSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.applicationId = 0;
        this.commentType = CommentType.NotSet;
        this.standardTexts = [];
        this.commentCategories = [];
    }
    pk() {
        return `${this.applicationId}/${this.commentType}`;
    }
}
CommentSettingsResource.schema = {
    commentCategories: [CommentCategoriesEntity]
};
CommentSettingsResource.urlRoot = apiResourceUrl("comment/settings");
export { CommentSettingsResource };
//# sourceMappingURL=CommentResource.js.map